// Init global object for packages that expect it
if (!window.global) window.global = window;
